import React, { FC } from "react";
import { ViewDeliverables } from "../viewDeliverables/ViewDeliverables";
import { ProgramTemplateDeliverablesRowValue } from "../../modelsAndSchemas/Models";
import { CreateDeliverable } from "../createDeliverable/CreateDeliverable";

interface EditDeliverableProps {
  handleCloseModal: () => void;
  pageId: string;
  show: boolean;
  selectedDeliverables: ProgramTemplateDeliverablesRowValue;
  programTemplateId: string;
  callApiFunction: () => void;
}

export const EditDeliverable: FC<EditDeliverableProps> = ({
  show,
  pageId,
  handleCloseModal,
  selectedDeliverables,
  programTemplateId,
  callApiFunction,
}) => {
  return (
    <>
      {selectedDeliverables?.isFrameworkActivityDeliverable === false && (
        <CreateDeliverable
          show={show}
          handleCloseModal={handleCloseModal}
          programTemplateId={programTemplateId ?? ""}
          pageId={pageId}
          getListOfDeliverablesApi={callApiFunction}
          isEditDeliverable={true}
          deliverableId={selectedDeliverables?.id}
        />
      )}

      {selectedDeliverables?.isFrameworkActivityDeliverable === true && (
        <ViewDeliverables
          show={show}
          pageId={pageId}
          handleCloseModal={handleCloseModal}
          isViewTemplate={true}
          isEditDeliverable={true}
          selectedDeliverableId={selectedDeliverables?.id}
          programTemplateId={programTemplateId}
          callApiFunction={callApiFunction}
          viewTemplateId={programTemplateId}
        />
      )}
    </>
  );
};
